import { Typography } from '@mui/material';
import { useTheme } from '@mui/material';
import { DatabaseTable } from '../../../../shared/components/ui/DatabaseTable';
import type { Resident } from '../../types/resident.types';
import { Badge } from '../../../../shared/components/ui/Badge';
import { getAttributeValue } from '../../../../utils/getAttributeLabelAndValue';

interface ResidentTableProps {
  residents: Resident[];
  isLoading: boolean;
  onView: (resident: Resident) => void;
}

export function ResidentTable({ residents, isLoading, onView }: ResidentTableProps) {
  const theme = useTheme();

 


  const processedResidents = residents.map(resident => {
    const document = getAttributeValue(resident.attributes, 'document');
    const phoneNumber = getAttributeValue(resident.attributes, 'phone_number');
    const birthDate = getAttributeValue(resident.attributes, 'birth_date');
    const statusFlag = getAttributeValue(resident.attributes, 'status_flag');
    const unit = getAttributeValue(resident.attributes, 'unitId');
    const sectionName = getAttributeValue(resident.attributes, 'section_name');
    console.log('sectionName',sectionName);
    let apartmentInfo = 'Não informado';
    if (unit) {
      apartmentInfo = unit;
      if (sectionName) {
        apartmentInfo += ` - ${sectionName}`;
      }
    }

    return {
      ...resident,
      document,
      phone_number: phoneNumber,
      birth_date: birthDate,
      status_flag: statusFlag,
      apartment: apartmentInfo,
    };
  });

  const columns = [
    {
      field: 'name',
      headerName: 'Nome',
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary} fontWeight={500}>
          {params.value || '-'}
        </Typography>
      )
    },
    {
      field: 'email',
      headerName: 'E-mail',
      flex: 1,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value || '-'}
        </Typography>
      )
    },
    {
      field: 'documentNumber',
      headerName: 'CPF',
      width: 140,
      renderCell: (params: any) => (
        <Typography
          sx={{
            fontFamily: 'monospace',
            fontSize: 12,
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : '#F3F4F6',
            color: theme.palette.mode === 'dark' ? theme.palette.text.primary : '#111827',
            px: 1,
            py: 0.5,
            borderRadius: 1,
            fontWeight: 600
          }}
        >
          {params.value || '-'}
        </Typography>
      )
    },
    {
      field: 'phoneNumber',
      headerName: 'Telefone',
      width: 140,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value || '-'}
        </Typography>
      )
    },
    {
      field: 'birth_date',
      headerName: 'Nascimento',
      width: 120,
      renderCell: (params: any) => (
        <Typography fontSize={14} color={theme.palette.text.primary}>
          {params.value ? new Date(params.value).toLocaleDateString('pt-BR') : '-'}
        </Typography>
      )
    },
    {
      field: 'apartment',
      headerName: 'Unidade',
      width: 120,
            renderCell: (params: any) => {
        const apartmentNumber = params.value?.includes('-') ? params.value.split('-').pop()?.trim() : params.value;
        return (
          <Typography
            fontSize={14}
            color={theme.palette.text.primary}
            sx={{
              backgroundColor: theme.palette.mode === 'dark' ? 'rgba(108, 99, 255, 0.1)' : '#F0F9FF',
              px: 1,
              py: 0.5,
              borderRadius: 1,
              fontWeight: 500
            }}
          >
            {apartmentNumber || params.value}
          </Typography>
        );
      }
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 100,
      renderCell: (params: any) => (
        <Badge color={params.value === 'active' ? 'success' : 'default'}>
          {params.value}
        </Badge>
      )
    },
  ];

  return (
    <DatabaseTable
      rows={processedResidents}
      columns={columns}
      loading={isLoading}
      onView={onView}
      hideDelete
      hideEdit
    />
  );
}